module.exports = __webpack_public_path__ + "media/images/svg/lock-b090dbbd6eeff2924327f680f97fc4ee.svg";